import { render, staticRenderFns } from "./PagePayeeInfoEdit.vue?vue&type=template&id=5206bdae&scoped=true&"
import script from "./PagePayeeInfoEdit.vue?vue&type=script&lang=ts&"
export * from "./PagePayeeInfoEdit.vue?vue&type=script&lang=ts&"
import style0 from "./PagePayeeInfoEdit.vue?vue&type=style&index=0&id=5206bdae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5206bdae",
  null
  
)

export default component.exports